import { shell } from '../../shell/shellClasses';

/** Temporary debug download. Browser cannot write exports/debug/; files go to Downloads. */
export function BlockCsvButton({
  disabled,
  onClick,
  label = 'CSV',
}: {
  disabled?: boolean;
  onClick: () => void;
  label?: string;
}) {
  return (
    <button
      type="button"
      className={`${shell.control} ${shell.focusRing} border-transparent bg-transparent ${shell.muted} ${shell.hoverRow}`}
      disabled={disabled}
      onClick={onClick}
    >
      {label}
    </button>
  );
}
